import React from 'react';
import { useUserThunkDispatch } from 'hooks';
import { userActions } from 'store/user';
import {
  getIdleLogoutMinutes,
  isSessionBusy,
  startSessionActivity,
  touchSessionActivity,
} from 'utils/session-activity';

const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'wheel', 'touchstart', 'scroll'];
const CHECK_INTERVAL_MS = 5000;
// mousemove и scroll приходят десятками в секунду
const TOUCH_INTERVAL_MS = 5000;

/** Завершает сессию, если таймаут вышел, а человек ничего не делает и ничего не загружается */
export default function useSessionIdle() {
  const userDispatch = useUserThunkDispatch();

  React.useEffect(() => {
    let lastTouch = 0;

    const handleActivity = () => {
      const now = Date.now();
      if (now - lastTouch >= TOUCH_INTERVAL_MS) {
        lastTouch = now;
        touchSessionActivity();
      }
    };

    const check = () => {
      if (isSessionBusy()) {
        touchSessionActivity();
      } else if (getIdleLogoutMinutes() > 0) {
        userDispatch(userActions.idleSignOut);
      }
    };

    startSessionActivity();
    const timer = window.setInterval(check, CHECK_INTERVAL_MS);
    ACTIVITY_EVENTS.forEach((event) => {
      window.addEventListener(event, handleActivity, { capture: true, passive: true });
    });

    return () => {
      clearInterval(timer);
      ACTIVITY_EVENTS.forEach((event) => {
        window.removeEventListener(event, handleActivity, { capture: true });
      });
    };
  }, []);
}
